/* eslint-disable */
import i18next from 'i18next';
import VueI18Next from "@panter/vue-i18next";
import Vue from 'vue';

Vue.use(VueI18Next);

class I18n {
  constructor() {
    this.impl = i18next;
  }

  init(options) {
    return this.impl.init(options)
      .then((t) => {
        this.t = function (...args) {
          return t(...args);
        }.bind(this);

        this.getFixedT = function (...args) {
          return this.impl.getFixedT(...args);
        }.bind(this);
      })
      .catch((e) => {
        console.log('something went wrong loading', e);
      })
  }

  initPlugin() {
    return new VueI18Next(i18next);
  }
}

export default new I18n();





// WEBPACK FOOTER //
// ./src/manager/i18n.js